import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionReveal from "@/components/SectionReveal";
import { api } from "@/auth/AuthContext";
import { JourneyCard } from "@/pages/JourneysShop";
import { useLang } from "@/contexts/LangContext";
import { jx } from "@/i18n/journeyLabels";

const CuratedJourneys = () => {
  const [journeys, setJourneys] = useState([]);
  const { lang } = useLang();
  const L = jx(lang);
  useEffect(() => { api.get("/journeys?featured=1").then((r) => setJourneys(r.data.journeys.slice(0, 3))).catch(() => {}); }, []);
  if (!journeys.length) return null;
  return (
    <section id="journeys" className="py-20 md:py-28 bg-[#F7F5F0]" data-testid="curated-journeys">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionReveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#C62828] font-semibold">✦ {L.homeEyebrow}</p>
          <div className="mt-3 flex flex-wrap items-end justify-between gap-4">
            <h2 className="font-heading text-4xl md:text-5xl text-[#0E2A5C] leading-tight">{L.homeTitle2}</h2>
            <Link to="/journeys" data-testid="explore-all-journeys"
              className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-[#C62828] hover:gap-3 transition-all">
              {L.viewAll} <ArrowRight size={14} />
            </Link>
          </div>
          <p className="mt-4 text-[#4A4A4A] max-w-2xl">{L.homeIntro}</p>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {journeys.map((j) => <JourneyCard key={j.slug} j={j} />)}
          </div>
        </SectionReveal>
      </div>
    </section>
  );
};

export default CuratedJourneys;
